import React, { useState, useEffect, useRef } from 'react'; 
import Confetti from 'react-confetti';
import './scss/puzztime.scss';

import Carta from './components/carta';

import { initializeApp } from "firebase/app";
import { getAnalytics,logEvent } from "firebase/analytics";

import ListaDias from './ListaDias';
import ListaJuegos from './ListaJuegos';
import Parejas from './Parejas';
import Ahorcado from './Ahorcado';
import Sudoku from './Sudoku';
import { BrowserRouter, Routes, Route, Link, useLocation, useNavigate ,HashRouter } from 'react-router-dom';

import LateralJuegos from './components/LateralJuegos';

import juegos from './assets/juegos.json';


/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* import '@ionic/react/css/palettes/dark.always.css'; */
/* import '@ionic/react/css/palettes/dark.class.css'; */
//import '@ionic/react/css/palettes/dark.system.css';

/* Theme variables */
//import './theme/variables.css';

//setupIonicReact();




/*const App: React.FC = () => (
  <div>
    <h2>Parejas</h2>
    <img src="public/iconos/caballo.png"/>
    <Carta></Carta>
  </div>
);*/

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {

  const firebaseConfig = {
  apiKey: "AIzaSyCceVPpjBFbA_khqjXABlFtdex6wU6YWPM",
  authDomain: "everyday---deia.firebaseapp.com",
  projectId: "everyday---deia",
  storageBucket: "everyday---deia.firebasestorage.app",
  messagingSenderId: "789110585317",
  appId: "1:789110585317:web:5d01114092fe374edce10c",
  measurementId: "G-N0EC1VFRC5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);





 return (
  <div>
    <ScrollToTop />
    <LateralJuegos></LateralJuegos>

        <Routes>
          <Route path="/" element={<ListaJuegos />} />
          <Route path="/dias/:juego" element={<ListaDias />} />
          <Route path="/parejas/:dia" element={<Parejas />} />
          <Route path="/ahorcado/:dia" element={<Ahorcado />} />
          <Route path="/sudoku/:dia" element={<Sudoku />} />
          <Route path="*" element={<ListaDias />} />
        </Routes>



         </div>
      

    
  )
}

export default App;
